import { KEYBOARD_SHORTCUT_SETTINGS_ROUTE, SHELL_SETTINGS_ROUTE } from './../../common/routes'
import { noop, navigateToUrl } from '../../common/helpers'
import { openNewTabFor } from '../../common/dom-helpers'
import { environment } from '../../environments'
import { getLaunchDarklyFlag } from '../../services/feature-flags'
import { LaunchDarklyVariations } from '../../services/feature-flags/models'
import { asTranslationKey } from '../../common/translate-helpers/i18n-utils'
import { isGoToMeetingCustomer } from '../../services/identity/entitlement'
import { getShellAuth, getShellNamespaces, getShellAnalytics } from '../../common/shell-api-helpers'
import type { MenuItem, SeparatorMenuItem } from '../menu-item/menu-item-models'
import { MenuItemType } from '../menu-item/menu-item-models'
import { setupUserReport } from '../user-report'
import type { ResolveNamespace } from '../../services/namespaces/resolve-namespace'
import { RESOLVE_NAMESPACE } from '../../services/namespaces/resolve-namespace'
import { html } from 'lit-element'

const separatorItem: SeparatorMenuItem = {
  type: MenuItemType.SEPARATOR,
}

export const menuItems: readonly MenuItem[] = [
  separatorItem,
  {
    href: '#',
    type: MenuItemType.NORMAL,
    executeFunction: () => {
      openNewTabFor(environment().profileUrl)
    },
    labelKey: asTranslationKey('Edit Profile'),
    isExternalLink: true,
    dataTest: 'edit-profile',
  },
  separatorItem,
  {
    type: MenuItemType.NORMAL,
    href: '#',
    executeFunction: noop,
    labelKey: asTranslationKey('About'),
    dataTest: 'about',
    isVisible: () => false, // The version is displayed in the last item of avatar popover menu. When chameleon supports a way to implement a sub menu we should enable this. https://jira.ops.expertcity.com/browse/SCORE-1217
  },
  {
    type: MenuItemType.CUSTOM,
    render: () => html`<goto-avatar-update-menu-item></goto-avatar-update-menu-item>`,
    dataTest: 'update',
  },
  {
    type: MenuItemType.NORMAL,
    href: '#',
    executeFunction: () => {
      openNewTabFor(environment().helpUrl)
    },
    labelKey: asTranslationKey('Help'),
    isExternalLink: true,
    isVisible: () => !!getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_AVATAR_POPOVER_HELP_MENU_ITEM),
    dataTest: 'help',
  },
  {
    type: MenuItemType.NORMAL,
    href: KEYBOARD_SHORTCUT_SETTINGS_ROUTE,
    executeFunction: () => {
      navigateToUrl(`${KEYBOARD_SHORTCUT_SETTINGS_ROUTE}`)
    },
    labelKey: asTranslationKey('Keyboard shortcuts'),
    isVisible: () => !!getLaunchDarklyFlag(LaunchDarklyVariations.SHELL_HOTKEY_SETTINGS),
    dataTest: 'keyboard-shortcuts',
  },
  {
    type: MenuItemType.NORMAL,
    href: SHELL_SETTINGS_ROUTE,
    executeFunction: () => {
      navigateToUrl(`${SHELL_SETTINGS_ROUTE}`)
    },
    labelKey: asTranslationKey('Settings'),
    isVisible: () => true,
    dataTest: 'settings',
  },
  {
    type: MenuItemType.NORMAL,
    href: '#',
    executeFunction: () => {
      const resolveNamespace = getShellNamespaces().retrieve<ResolveNamespace>(RESOLVE_NAMESPACE)
      resolveNamespace.commands.openCreateIncidentDialog.execute()
      getShellAnalytics().track('GoTo > Open Ticket Resolve', { action: 'Click', event: 'Open', from: 'Topbar' })
    },
    labelKey: asTranslationKey('Contact my admin'),
    isVisible: () => {
      const resolveNamespace = getShellNamespaces().retrieve<ResolveNamespace>(RESOLVE_NAMESPACE)
      return resolveNamespace.commands.openCreateIncidentDialog.isHandled()
    },
    dataTest: 'createResolveIncident',
  },
  {
    type: MenuItemType.NORMAL,
    href: '#',
    executeFunction: () => {
      // EAP - Hard coded until removed
      window.open('https://logmeinvoc.iad1.qualtrics.com/jfe/form/SV_39obCEnQHAKSR7g', '_blank', 'noreferrer')
    },
    isExternalLink: true,
    labelKey: asTranslationKey('Feedback'),
    isVisible: isGoToMeetingCustomer,
    dataTest: 'feedbackG2M',
  },
  // END of EAP - Temporary until the new setting is available inside goto app.
  {
    type: MenuItemType.NORMAL,
    href: '#',
    executeFunction: () => {
      const { openFeedbackDialog } = setupUserReport(window)
      openFeedbackDialog()
    },
    labelKey: asTranslationKey('Feedback'),
    isVisible: () => !isGoToMeetingCustomer(), // EAP - Temporary until then it become always visible
    dataTest: 'feedback',
  },
  separatorItem,
  {
    type: MenuItemType.NORMAL,
    href: '#',
    executeFunction: () => getShellAuth().logout(),
    labelKey: asTranslationKey('Sign out'),
    dataTest: 'logout',
  },
]
